import React from 'react';
import { Paper } from 'housecall-ui';
import { QUESTION_TYPE, REMINDER_TYPE, RequestGuideNode } from 'resources/CustomerIntakeFlow/requestGuide';

import { QuestionContent } from 'components/CustomerIntakeSettings/requestGuide/QuestionContent';

import { isHcpAssistIndustryNode } from './helpers';
import { ReminderContent } from './ReminderContent';
import { RequestGuideCard, RequestGuideNodeMenuAction } from './RequestGuideCard';

type RequestGuideCardListProps = {
  data: RequestGuideNode[];
  onMenuAction: (arg: RequestGuideNodeMenuAction, node: RequestGuideNode) => void;
  isHcpAssistImpersonated?: boolean;
  editable?: boolean;
};

export const RequestGuideCardList = ({
  data,
  onMenuAction,
  isHcpAssistImpersonated,
  editable,
}: RequestGuideCardListProps) =>
  data?.length > 0 ? (
    <Paper elevation={1}>
      {data.map((item, index) => (
        <RequestGuideCard
          node={item}
          isFirst={index === 0}
          isLast={index === data.length - 1}
          key={index}
          onMenuAction={(option) => onMenuAction(option, item)}
          isHcpAssistImpersonated={!!isHcpAssistImpersonated}
          editable={editable ?? !isHcpAssistIndustryNode(item)}
        >
          {({ handleOptionsOpen, showBranching, onBranchToggle, childrenEditable }) => (
            <>
              {item.type === QUESTION_TYPE && (
                <QuestionContent
                  showBranching={showBranching}
                  onBranchToggle={onBranchToggle}
                  question={item}
                  branches={Object.keys(item.childNodes || {}).length}
                  onOptionsOpen={handleOptionsOpen}
                  onMenuAction={onMenuAction}
                  isHcpAssistImpersonated={!!isHcpAssistImpersonated}
                  editable={childrenEditable}
                />
              )}

              {item.type === REMINDER_TYPE && (
                <ReminderContent
                  text={item.note}
                  title={item.title}
                  onOptionsOpen={handleOptionsOpen}
                  editable={childrenEditable}
                />
              )}
            </>
          )}
        </RequestGuideCard>
      ))}
    </Paper>
  ) : null;
